// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginForm_root__2aO_O","form":"LoginForm_form__2esor","button":"LoginForm_button__vrnvW"};